"use client";
import type { ReactElement, RefObject } from "react";
import { getFontFamily } from "@/theme/typography";
import { AXIS_HEIGHT, LABEL_COLUMN_WIDTH, } from "./gantt-constants";
import { selectGanttLabelTaskRowModel } from "./gantt-label-row-selectors";
import { selectTaskInteractionState, selectTimelineRowsHeight, } from "./gantt-render-selectors";
import type { GanttLayout } from "./gantt-types";
import { GanttLabelSectionRow } from "./GanttLabelSectionRow";
import { GanttLabelTaskRow } from "./GanttLabelTaskRow";
export interface GanttLabelsPaneProps {
    labelsPaneRef: RefObject<HTMLDivElement | null>;
    layout: GanttLayout;
    hoveredTaskId: string | null;
    highlightedTaskIds: ReadonlySet<string>;
    onToggleSection: (sectionIndex: number) => void;
}
export function GanttLabelsPane({ labelsPaneRef, layout, hoveredTaskId, highlightedTaskIds, onToggleSection, }: GanttLabelsPaneProps): ReactElement {
    return (
      <div className="cmarkdowngantt-labels-pane" ref={labelsPaneRef} style={{
            width: LABEL_COLUMN_WIDTH,
            minWidth: LABEL_COLUMN_WIDTH,
            maxWidth: LABEL_COLUMN_WIDTH,
            flexShrink: 0,
            borderRight: "1px solid rgba(255,255,255,0.05)",
            backgroundColor: "rgba(15, 19, 29, 0.55)",
            position: "sticky",
            left: 0,
            zIndex: 5,
            overflowY: "scroll",
            overflowX: "hidden",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
        }}>
        <div style={{
            height: AXIS_HEIGHT,
            display: "flex",
            alignItems: "center",
            padding: "0 12px",
            color: "rgba(255,255,255,0.5)",
            fontFamily: getFontFamily(),
            fontSize: 11,
            fontWeight: 600,
            borderBottom: "1px solid rgba(255,255,255,0.05)",
            letterSpacing: "0.08em",
            textTransform: "uppercase",
        }}>
          Labels
        </div>

        <div style={{
            position: "relative",
            height: selectTimelineRowsHeight({ chartHeight: layout.chartHeight }),
        }}>
          {layout.sectionRows.map((sectionRow) => (<GanttLabelSectionRow key={`label-section-${sectionRow.sectionIndex}`} sectionRow={sectionRow} onToggleSection={onToggleSection}/>))}

          {layout.taskRows.map((taskRow) => {
            const taskLayout = layout.taskLayoutById.get(taskRow.taskId);
            if (!taskLayout) {
                return null;
            }
            const interactionState = selectTaskInteractionState({
                taskId: taskLayout.task.id,
                hoveredTaskId,
                highlightedTaskIds,
            });
            return (<GanttLabelTaskRow key={`label-task-${taskLayout.task.id}`} taskRow={taskRow} model={selectGanttLabelTaskRowModel({
                    taskLayout,
                    interactionState,
                })}/>);
        })}
        </div>
      </div>
    );
}
